import {vuei18n} from '../plugins/i18n';

export const recurringMiscIntervalOptions = {
  MONTHS_1: {text: vuei18n.t('general.intervalMonthly'), value: 'MONTHS_1'},
  MONTHS_2: {text: vuei18n.t('general.intervalBiMonthly'), value: 'MONTHS_2'},
  MONTHS_3: {text: vuei18n.t('general.intervalQuarterly'), value: 'MONTHS_3'},
  MONTHS_6: {text: vuei18n.t('general.intervalBiYearly'), value: 'MONTHS_6'},
  MONTHS_12: {text: vuei18n.t('general.intervalYearly'), value: 'MONTHS_12'},
};
